import { GuardedDeletionService, PropertyTypeCreateDto, PropertyTypeDto, PropertyTypeExcelDownloadDto, PropertyTypeService, PropertyTypeUpdateDto } from 'orchestrator';
import { Component, inject } from '@angular/core';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import { PROPERTYTYPE_CONFIG, PROPERTYTYPE_FIELDS } from './property-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-property-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, PropertyTypeService, ConfirmationService],
  templateUrl: './property-type.html',
  styleUrl: './property-type.scss',
})
export class PropertyType extends BaseCrudComponent<
  PropertyTypeDto,
  PropertyTypeCreateDto,
  PropertyTypeUpdateDto,
  PropertyTypeExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  service = {
    ...inject(PropertyTypeService),
    deleteByIds: (ids: number[]) => this.guardedDeletion.deleteByIds('PropertyType', ids),
  };
  config = PROPERTYTYPE_CONFIG;
  fields = PROPERTYTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: PropertyTypeDto): PropertyTypeUpdateDto {
    return {
      name: data.name,
      code: data.code,
      remsoftName: data.remsoftName,
      isSapFicoApplied: data.isSapFicoApplied,
      isFOManagement: data.isFOManagement,
      propertyTypeGroupId: data.propertyTypeGroupId,
      nextPropertyTypeId: data.nextPropertyTypeId,
      rowVersion: selected.rowVersion,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'PropertyType';
  }
}
